import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Game from "./components/Game";
import Home from "./components/Home";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/:code" element={<Game />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
